import React from 'react';
import classNames from 'classnames/bind';
import { Link, StarFilledIcon, Text } from '@beef/ui-kit';
import { determineDeclension } from '@beef/utils';
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
export var getDeviceTotalReviews = function getDeviceTotalReviews(reviews) {
  var _reviews$count;
  var count = (_reviews$count = reviews === null || reviews === void 0 ? void 0 : reviews.count) !== null && _reviews$count !== void 0 ? _reviews$count : 0;
  var reviewsCount = determineDeclension(['отзыв', 'отзыва', 'отзывов'], count);
  return "".concat(count, " ").concat(reviewsCount);
};
export var Reviews = function Reviews(_ref) {
  var reviews = _ref.reviews,
    className = _ref.className;
  var totalReviews = getDeviceTotalReviews(reviews);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper', className)
  }, !!(reviews !== null && reviews !== void 0 && reviews.average) && /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper-link')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size6-m"
  }, reviews.average)), /*#__PURE__*/React.createElement("div", null, (reviews === null || reviews === void 0 ? void 0 : reviews.link) && /*#__PURE__*/React.createElement(Link, {
    href: reviews.link,
    icon: /*#__PURE__*/React.createElement(StarFilledIcon, {
      fill: "#FFC800",
      size: "xs"
    }),
    isNoUnderline: true,
    onClick: reviews === null || reviews === void 0 ? void 0 : reviews.onClick,
    size: "size6-r",
    variant: "light"
  }, totalReviews)));
};